import React from 'react';

// CONTEXT
import { useRecordContext } from 'helpers/getRecordData';

// HELPERS
import useRecordView from 'helpers/getRecordView';

// LOG PARTS
import Log from '../../prototype/Log';

// STYLES
import styles from './dealTasksPill.module.scss';

// MAIN COMPONENT
const DealTasksPill = () => {

  // CONTEXT
  const { record: { aryCompletedDealTasks = [], aryPendingDealTasks = [] } = {} } = useRecordContext() || {};
  const { isAmFinance } = useRecordView();

  // RENDER
  return (
    <Log.Pill className={styles.completedPill}><Log.Pill className={styles.pendingPill}>{aryPendingDealTasks.length}</Log.Pill> {isAmFinance ? aryCompletedDealTasks.length + aryPendingDealTasks.length : aryCompletedDealTasks.length}</Log.Pill>
  );
}

// EXPORT
export default DealTasksPill;
